var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"button sort",attrs:{"role":"button"}},[_c('span',{staticClass:"tip"},[_vm._v("位置の移動")]),_c('IcArrowTop',{staticClass:"icn sm up"}),_c('IcArrowDown',{staticClass:"icn sm down"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }